/**
 * Roles the library can fill. Themes store ids; they do not store files.
 *
 * A face reference is either a built-in id (`work-sans`) or `face:<id>`.
 * `custom:<id>` is the older per-theme upload prefix and resolves the same way.
 */

export const FACE_PREFIX = 'face:';
export const CUSTOM_FONT_PREFIX = 'custom:';

export const FACE_ROLES = [
    { id: 'body', themePath: 'fonts.body', cssVar: '--font-body', label: 'Body font' },
    { id: 'heading', themePath: 'fonts.heading', cssVar: '--font-heading', label: 'Heading font' },
    { id: 'nav', themePath: 'fonts.nav', cssVar: '--font-nav', label: 'Navigation font' },
    { id: 'wordmark', themePath: 'fonts.wordmark', cssVar: '--font-display', label: 'Wordmark font' },
    // Unset means each caption keeps its built-in face, so nothing is emitted.
    { id: 'caption', themePath: 'fonts.caption', cssVar: '--font-caption', label: 'Caption font', optional: true },
];

export const GLYPH_ROLES = [
    { id: 'close', moduleId: 'icon-close', label: 'Close' },
    { id: 'chevron-left', moduleId: 'icon-prev', label: 'Previous' },
    { id: 'chevron-right', moduleId: 'icon-next', label: 'Next' },
    { id: 'play', moduleId: 'icon-play', label: 'Play' },
    { id: 'pause', moduleId: 'icon-pause', label: 'Pause' },
];

export const DEFAULT_ICON_SET_ID = 'default';

/** @param {string} id */
export function faceRef(id) {
    return `${FACE_PREFIX}${id}`;
}

/**
 * The uploaded face id inside a theme value, or null when the value is a built-in id.
 * @param {string} value
 * @returns {string|null}
 */
export function uploadedFaceId(value) {
    if (typeof value !== 'string') return null;
    if (value.startsWith(FACE_PREFIX)) return value.slice(FACE_PREFIX.length);
    if (value.startsWith(CUSTOM_FONT_PREFIX)) return value.slice(CUSTOM_FONT_PREFIX.length);
    return null;
}

/** @param {string} moduleId */
export function glyphRoleForModule(moduleId) {
    return GLYPH_ROLES.find((role) => role.moduleId === moduleId) || null;
}
